// controllers/search_controller.js
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    onMouseEnter() {
        for (const other of document.querySelectorAll('.event-featured-transition')) {
            other.classList.remove('event-featured-transition');
        }

        this.element.classList.add('event-featured-transition');
    }

    onMouseLeave() {
        this.element.classList.remove('event-featured-transition');
    }
}
